import commonApi from '@/common/api/commonApi.js'

const state = {
  // 省市区
  areas: [],
  // 所有运营商
  operators: [],
  // 所有站点
  stations: [],
  // 所有集团
  groups: [],
  // 运营商和集团
  groupWithOperator: []
}

const getters = {
  areas(state) {
    return state.areas
  },
  operators(state) {
    return state.operators
  },
  stations(state) {
    return state.stations
  },
  groups(state) {
    return state.groups
  },
  groupWithOperator(state) {
    return state.groupWithOperator
  }
}

const mutations = {
  areas(state, areas) {
    state.areas = areas
  },
  operators(state, operators) {
    state.operators = operators
  },
  stations(state, stations) {
    state.stations = stations
  },
  groups(state, groups) {
    state.groups = groups
  },
  groupWithOperator(state, values) {
    state.groupWithOperator = values
  }
}

const actions = {
  getAllAreas({commit}) {
    console.log('从后台获取省市区信息')
    return new Promise((resolve, reject) => {
      commonApi.getAllAreas().then(res => {
        if (res && res.data && res.data.length > 0) {
          commit('areas', res.data)
          resolve(res.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOperators({commit}) {
    console.log('从后台获取运营商信息')
    return new Promise((resolve, reject) => {
      commonApi.getOperators().then(res => {
        if (res && res.data && res.data.length > 0) {
          commit('operators', res.data)
          resolve(res.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetOperators({commit}){
    return new Promise(resolve => {
      commit('operators', [])
      commit('groupWithOperator', [])
      resolve()
    })
  },
  getStations({commit}) {
    console.log('从后台获取站点信息')
    return new Promise((resolve, reject) => {
      commonApi.getStations({}).then(res => {
        if (res && res.data && res.data.length > 0) {
          commit('stations', res.data)
          resolve(res.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetStations({commit}){
    return new Promise(resolve => {
      commit('stations', [])
      resolve()
    })
  },
  getGroups({commit}) {
    console.log('从后台获取集团信息')
    return new Promise((resolve, reject) => {
      commonApi.getGroups({}).then(res => {
        if (res && res.data && res.data.length > 0) {
          commit('groups', res.data)
          resolve(res.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getGroupWithOperator({commit}) {
    console.log('从后台获取运营商-集团信息')
    return new Promise((resolve, reject) => {
      commonApi.getGroupWithOperator().then(res => {
        console.log(JSON.stringify(res.data))
        if (res && res.data && res.data.length > 0) {
          commit('groupWithOperator', res.data)
          resolve(res.data)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetGroups({commit}){
    return new Promise(resolve => {
      commit('groups', [])
      commit('groupWithOperator', [])
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common.js